import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom'
import Icon from '../../../components/Icon/Icon';
import ICONS from '../../../components/Icon/IconPaths';
import avatar from '../../../assets/img/avatar.jpg'

class NavbarMobile extends Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    window.addEventListener('load', this.handlePathChange);
    window.addEventListener('popstate', this.handlePathChange);
    window.addEventListener('click', this.handlePathChange);
  }

  handlePathChange = (event) => {

    const pathName = window.location.pathname

    if (pathName === '/') {
      this.setState({ briefingIsActive: true, businessIsActive: false, settingsIsActive: false, aboutIsActive: false })
    }
    if (pathName === '/business') {
      this.setState({ briefingIsActive: false, businessIsActive: true,  settingsIsActive: false, aboutIsActive: false })
    }
    if (pathName === '/settings') {
      this.setState({ briefingIsActive: false, businessIsActive: false, settingsIsActive: true, aboutIsActive: false })
    }
    if (pathName === '/account') {
      this.setState({ briefingIsActive: false, businessIsActive: false, settingsIsActive: true, aboutIsActive: false })
    }
    if (pathName === '/about') {
      this.setState({ briefingIsActive: false, businessIsActive: false, settingsIsActive: false, aboutIsActive: true })
    }
  }


  render() {
    return (
      <div>
        <button className={ this.state.open === true ? "overlay-button open" : "overlay-button closed" } onClick={this.handleClose}>
          <div onClick={this.handleClose} className="overlay"></div>
        </button>
        <div className="nav-wrapper mobile p-2 p-sm-3 d-flex justify-content-between align-items-center d-lg-none position-fixed">
          <button className="btn --icon"onClick={this.handleClickOpen}>
            <Icon icon={ICONS.MENU} size="32" className="Icon --Green-base" />
          </button>
          <div className="logo mobile d-flex align-items-center">
            <Link to="/home">
              <Icon icon={ICONS.LOGO} size="32" viewbox="64" className="Icon --Green-base" />
            </Link>
          </div>
          <Link to="/settings" className="avatar-anchor"><img src={avatar} className="avatar mobile"/></Link>
        </div>
        <div className={ this.state.open === true ? "sidebar open" : "sidebar closed" }>
          <div className="p-2 p-sm-3 d-flex justify-content-between align-items-center d-lg-none position-sticky">
            <button className="btn --icon" onClick={this.handleClose}>
              <Icon icon={ICONS.CLOSE} size="32" className="Icon --Green-base" />
            </button>
          </div>
          <div className="m-5">
            <ul className="nav-list">
              <li><button onClick={this.handleClose}><NavLink exact={true} activeClassName="active" to="/"><h5>L’edizione del giorno</h5></NavLink></button></li>
              <li><button onClick={this.handleClose}><NavLink activeClassName="active" to="/business"><h5>Abbonamento Aziendale</h5></NavLink></button></li>
              <li><button onClick={this.handleClose}><NavLink activeClassName="active" to="/settings"><h5>Impostazioni</h5></NavLink></button></li>
              <li><button onClick={this.handleClose}><NavLink activeClassName="active" to="/about"><h5>Chi siamo</h5></NavLink></button></li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

}

export default NavbarMobile;